<template>
  <div class="table table-bg">
    <div class="table-header center">
      <div class="table-tlt center-left">
        <h2>부서 등록</h2>
      </div>
      <div class="table-btn center-right">
        <div>
          <button class="btn btn-140" @click="goList">부서 리스트</button>
        </div>
      </div>
    </div>
    <div class="table-desc">
      <div class="table-content">
        <table>
          <tr>
            <td class="header">부서 ID</td>
            <!-- TODO <td><input type="text" v-model="division.divisionAlias" /></td> -->
            <td>-자동생성-</td>
          </tr>
          <tr>
            <td class="header">회사 ID</td>
            <!-- TODO <td>{{ company.companyAlias }}</td> -->
            <td>{{ company.companyID }}</td>
          </tr>
          <tr>
            <td class="header">회사 역할</td>
            <td>{{ $getConstName('companyScope', company.scope) }}</td>
          </tr>
        </table>
        <div class="vertical-line"></div>
        <table>
          <tr>
            <td class="header">부서 이름</td>
            <td><input type="text" v-model="division.divisionName" /></td>
          </tr>
          <tr>
            <td class="header">회사 이름</td>
            <td>{{ company.companyName }}</td>
          </tr>
          <tr>
            <td class="header"></td>
            <td></td>
          </tr>
        </table>
      </div>
      <div class="table-btn center">
        <button class="btn btn-140 btn-blue-line" @click="excuteUpdate">
          <span v-if="!processing" class="process">등록</span>
          <ButtonLoading v-else></ButtonLoading>
        </button>
        <button
          class="btn btn-right"
          @click="cancelUpdate"
        >취소</button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */

import Configuration from '@/js/Configuration';
import ButtonLoading from '@/components/include/ButtonLoading';

export default {
  props: [
    'company',
  ],
  components: {
    ButtonLoading,
  },
  data: () => ({
    division: {
      companyID: null,
      divisionAlias: null,
      divisionName: null,
    },
    processing: false,
  }),
  methods: {
    async excuteUpdate() {
      try {
        this.processing = true;
        const url = `${Configuration.value(
          'CACCOUNT_ADDRESS',
        )}/api/v1/caccount/division`;

        this.division.companyID = this.company.companyID;
        const param = this.division;
        const createResult = await this.$http.post(url,
          param,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          });
        if (createResult.status !== 200) {
          throw new Error(`Response status is "${createResult.status}"`);
        }
        if (createResult.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${createResult.data.resultCode}"`);
        }

        const company = {
          id: this.company.companyID,
          name: this.company.companyName,
          alias: this.company.companyAlias,
          registrationNo: this.company.registrationNo,
          scope: this.company.scope,
        };

        this.processing = false;
        this.$emit('refreshList', company, 'company', 1);
      } catch (e) {
        this.processing = false;
        console.error(e);
      }
    },
    cancelUpdate() {
      const company = {
        id: this.company.companyID,
        name: this.company.companyName,
        alias: this.company.companyAlias,
        registrationNo: this.company.registrationNo,
        scope: this.company.scope,
      };

      this.$emit('refreshList', company, 'company');
    },
    goList() {
      this.cancelUpdate();
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/account/division/DivisionCreate.vue